import PropTypes from "prop-types";
import React, { Component } from "react";
import { Grid, Box, CircularProgress } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import HeaderInfo from "../../waybee-ui/HeaderInfo/HeaderInfo";
import Group from "../../waybee-ui/Group";
import BackButton from "../../components/BackButton";
import StudentService from "../../services/StudentService";
import CollapseGroup from "../../waybee-ui/CollapseGroup";
import ResponsibleContact from "./components/ResponsibleContact";

class StudentContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      student: null
    };
  }

  componentDidMount() {
    this.getContactInfo();
  }

  getContactInfo = async () => {
    const { match } = this.props;
    const { studentId } = match.params;

    try {
      const student = await StudentService.getStudentById(studentId);
      this.setState({ student });
    } catch (e) {
      console.error(e);
    }
  };

  render() {
    const { student } = this.state;
    const { match } = this.props;
    const { studentId } = match.params;

    // const birthday = moment(student.birthday).format('D/MM/YYYY')

    return !student ? (
      <Box p={6} textAlign="center">
        <CircularProgress />
      </Box>
    ) : (
      <Grid container spacing={2}>
        <BackButton to={`/student/${studentId}`} />
        <Grid item xs={12}>
          <Group>
            <>
              <Box mb={2}>
                <HeaderInfo
                  name={student.name}
                  info={`R.A: ${student.ra}`}
                  photo={student.photo}
                />
              </Box>
              <CollapseGroup title="Mais informações">
                <ResponsibleContact
                  tel2={student.tel2}
                  tel1={student.tel}
                  email={student.email}
                  birthday={student.birthday}
                />
              </CollapseGroup>
              <CollapseGroup title="Responsáveis">
                {student.contacts.resp &&
                  student.contacts.resp.map(resp => (
                    <ResponsibleContact
                      name={resp.name}
                      tel2={resp.tel2}
                      tel1={resp.tel1}
                      email={resp.email}
                    />
                  ))}
              </CollapseGroup>
              {student.contacts.respTransport.length !== 0 && (
                <CollapseGroup title="Responsáveis de Transporte">
                  {student.contacts.respTransport.map(resp => (
                    <ResponsibleContact
                      name={resp.name}
                      tel2={resp.tel2}
                      tel1={resp.tel1}
                      email={resp.email}
                    />
                  ))}
                </CollapseGroup>
              )}
            </>
          </Group>
        </Grid>
      </Grid>
    );
  }
}

StudentContact.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.array
  }).isRequired
};
export default withRouter(StudentContact);
